import { updateApiBaseUrl } from '@/api/aquaApi'
import { SecureConfig } from '@/modules/Login/hooks/types'

/**
 * Aplicar la configuración segura obtenida a las APIs
 * @param config - Configuración segura del endpoint /me
 */
export const applySecureConfig = (config: SecureConfig): void => {
  const { apiUrls } = config

  // Actualizar la URL base de la API principal
  updateApiBaseUrl(apiUrls.app)

  console.log('Configuración segura aplicada a las APIs:', {
    appUrl: apiUrls.app,
    monitorUrl: apiUrls.monitor,
  })
}
